import React from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';
import CheckedXIcon from '@shared/components/CheckedXIcon';

/**
 * @typedef {object} AvailabilityCheckboxProps
 * @property {boolean} [checked]
 * @property {boolean} [disabled]
 * @property {(checked: boolean) => void} [onChange]
 * @property {string} [testId]
 */

/**
 * @param {AvailabilityCheckboxProps} props
 */
const AvailabilityCheckbox = props => {
  const { checked, disabled, onChange, testId } = props;

  return (
    <FormControlLabel
      className='availability-checkbox'
      data-testid={testId}
      control={
        <Checkbox
          name='Availability'
          color='default'
          checkedIcon={<CheckedXIcon />}
          disabled={disabled}
          checked={checked}
          onChange={e => onChange(e.target.checked)}
        />
      }
      label={<span className='bold'>Availability</span>}
      labelPlacement='start'
    />
  );
};

export default AvailabilityCheckbox;
